import { Component, OnInit } from '@angular/core';

import { TitleWrapperService } from '../_services/title-wrapper.service';

@Component({
  selector: 'app-help-page',
  templateUrl: './help-page.component.html',
  styleUrls: ['./help-page.component.scss']
})
export class HelpPageComponent implements OnInit {

  constructor(private titleService: TitleWrapperService) { }

  ngOnInit() {
    this.titleService.SetTitle('ABMP Continuing Education Help | ABMP CE Courses', true);
  }

  ToggleHLS() {
    if (window.localStorage.getItem("nohls") == "1") {
      window.localStorage.setItem("nohls", "0");
      location.reload();
    } else {
      if (confirm("This will disable HLS video and fallback to MP4. Are you sure?")) {
        window.localStorage.setItem("nohls", "1");
        location.reload();
      }
    }
  }
}
